<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <el-dialog title="填写补考原因" :visible.sync="showBkyy" :append-to-body="true" width="450px" center>
        <div style="height: 100px; text-align: center;">
          <div>
            <el-input type="textarea" v-model="ksyKsbkmd.bkyy" style="width:400px" placeholder="请输入 补考原因"></el-input>
          </div>
          <div style=" margin-top: 20px">
            <el-button type="primary" style="width: 100px" @click="resit()">确&nbsp;&nbsp;&nbsp;定</el-button>
          </div>
        </div>
      </el-dialog>
      <el-form :inline="true" :model="form" @submit.native.prevent>
        <el-row>
          <el-col :span="20" style="text-align:left">
            <el-form-item label="状态">
              <el-select v-model="form.zt">
                <el-option label="全部" value=""></el-option>
                <el-option label="已设置补考" value="1"></el-option>
                <el-option label="未设置补考" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="form.ksmc" style="width:400px" placeholder="请输入考生名称" @keyup.enter.native="query()"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="form.kszh" style="width:150px" placeholder="请输入考生账号" @keyup.enter.native="query()"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query()">查询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <el-form-item>
              <el-button type="success" @click="toYkksList()">已考考生</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-table :data="tableData" style="width: 100%" :border="true" height="400">
          <el-table-column label="考生账号" width="100"  prop="yhzh"/>
          <el-table-column label="考生姓名" width="100"  prop="ksxm"/>
          <el-table-column label="所属部门" width="120"  prop="bmmc"/>
          <el-table-column label="状态" width="120"  prop="bkzt"/>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleResit(scope.$index, scope.row)" :disabled="!scope.row.fhr || scope.row.bkcs" type="danger">
                {{scope.row.bkcs ? '补考中' : '补考'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import * as markingPaper from '@/api/markingPaper'
export default {
  data () {
    return {
      form: {
        ksid: null,
        zt: '',
        ksmc: '',
        kszh: ''
      },
      showBkyy: false,
      ksyKsbkmd: {},
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: []
    }
  },
  components: {
    myHeader
  },
  methods: {
    toYkksList () {
      const query = {
        ksid: this.form.ksid
      }
      this.$router.replace({
        path: '/markingPaper/list',
        query: query
      })
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign({ pageNo: this.currentPage, pageSize: this.pageSize }, this.form)
      markingPaper.getWkList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    },
    // 补考
    handleResit ($index, row) {
      this.$confirm('确定设置为补考？考生设置为补考后，会增加一次考试机会', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ksyKsbkmd.ksid = row.ksid
        this.ksyKsbkmd.yhid = row.yhid
        this.showBkyy = true
      }).catch(() => {})
    },
    resit () {
      markingPaper.resit(this.ksyKsbkmd).then(res => {
        this.$http.callback(res, () => {
          this.showBkyy = false
          this.$message.success(res.msg)
          this.query(this.currentPage)
        })
      })
    }
  },
  created () {
    this.form.ksid = this.$route.query.ksid
  },
  mounted () {
    // 进入页面后进行查询
    this.query()
  }
}
</script>
